(() => {
  const observedBanners = new WeakSet();

  const fitReleaseText = (banner) => {
    const text = banner.querySelector('.rpg-game-card__release-text');
    if (!text) return;

    text.style.setProperty('--rpg-release-text-scale', '1');

    const styles = getComputedStyle(banner);
    const availableWidth = Math.max(
      0,
      banner.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight),
    );
    const naturalWidth = text.scrollWidth;
    if (!availableWidth || !naturalWidth) return;

    const scale = Math.min(1, availableWidth / naturalWidth);
    text.style.setProperty('--rpg-release-text-scale', scale.toFixed(4));
  };

  const observeReleaseBanner = (banner) => {
    if (observedBanners.has(banner)) return;
    observedBanners.add(banner);
    fitReleaseText(banner);
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => fitReleaseText(banner)).observe(banner);
    }
  };

  const initializeReleaseLabels = (root = document) => {
    root.querySelectorAll('.rpg-game-card__release').forEach(observeReleaseBanner);
  };

  const initialize = () => {
    initializeReleaseLabels();
    document.fonts?.ready.then(() => initializeReleaseLabels());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initializeReleaseLabels(event.target));
})();
